import PageDescriptionFootnote from "./Footnote";

const PageDescription = (props: any) => {

    function renderObjectBody(data: any) {
        return { __html: data }
    }

    return (

        <section className="page-description mb-2">
            <div className="container">

                <div className="row justify-content-center">

                    {props.items?.map((item:
                        {
                            Subtitulo: string;
                            Descricao_x0020_Subtitulo: string | any[];
                            Corpo: string | any[];
                        }
                    ) => (

                        <div key="{item.Id}" className="col-lg-10">
                            <div className="page-description__title mb-lg-5">
                                <h3>
                                    {item?.Subtitulo}
                                </h3>
                            </div>
                            {/* 78 é equivalente ao tamanho de <div class="ExternalClass093971F2A6134EABA038A5A17777223A"><p>​​<br></p></div> quando o richtext do sharepoint está vazio */}
                            {item?.Descricao_x0020_Subtitulo?.length > 78 &&
                                <div className="page-description__desc mb-7 mb-lg-9">
                                    <p>
                                        <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao_x0020_Subtitulo)} />
                                    </p>
                                </div>
                            }

                            {(item?.Subtitulo?.length > 0 || item?.Corpo?.length > 0 || item?.Descricao_x0020_Subtitulo?.length > 0) &&
                                <div className="page-description__midias">
                                    <PageDescriptionFootnote />
                                </div>
                            }
                            <br></br>
                            <div className="page-description__title mb-lg-5">
                                {/* {item?.Corpo} */}
                                {item.Corpo &&
                                    <>
                                        {/* <br></br><br></br> */}
                                        <span dangerouslySetInnerHTML={renderObjectBody(item.Corpo)} />
                                        <hr></hr> </>}
                            </div>

                        </div>

                    ))}
                </div>

            </div>
        </section>

    )
};
export default PageDescription;